import { Container } from './styles';

import renata from '../../assets/img/re.jpg'
import wellton from '../../assets/img/well2.jpg'
import scroll from '../../assets/img/scroll.png'

export function Couple() {

    return (
        <Container id="casal">
            <div className="top">
                <h1>Conheça os futuros Sr. e Sra. Quirino!</h1>
                <p>Assim, permanecem agora estes três: a fé, a esperança e o amor. O maior deles, porém, é o amor.</p>
                <span>1 Coríntios 13:13</span>
            </div>
            <div className="couple">
                <div className="img">
                    <img src={renata} alt="Renata Laís" />
                </div>
                <div className="history">
                    <div style={{display: 'flex', marginLeft: '22px', marginTop: '2px'}}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <h2>Renata Laís</h2>
                            <h3>Escrito pela noiva</h3>  
                        </div>
                        <div className="scroll">
                            <img src={scroll} className='scrollRight' alt="Desça com o dedo para ler mais" />
                        </div>  
                    </div>                
                    <p>
                        Vamos realizar um grande sonho! Esperamos muito por isso e estamos com grandes expectativas. 
                        Sou muito grata a Deus por Ele ter feito nossos caminhos se encontrarem e juntos decidimos viver essa história. 
                        Desde o início vejo o quanto Ele está com a gente, mesmo quando vieram os questionamentos Ele nos impulsionou a permanecermos juntos olhando pra frente. 
                        Eu admiro muito sua maneira de cuidar das pessoas, você não fala mas demonstra nas atitudes. Você tem características que me ajudam a melhorar e somar o que tenho de melhor. Deus trabalha muito em nós dois com nossas personalidades. Gosto tanto do seu jeito trabalhador, alegre, seu temor nas coisas do Senhor e jeito leve de viver. 
                        Estou ansiosa em viver o propósito de vida sendo uma só carne com você.
                        <br/> 
                        Eu te amo muito! 
                        Com amor, Renata Laís.
                    </p>                    
                </div>
            </div>
            <div className="couple">
                <div className="history">
                    <div style={{display: 'flex', marginLeft: '22px'}}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <h2>Wellton Quirino</h2>
                            <h3>Escrito pelo noivo</h3>
                        </div>
                        <div className="scroll">
                            <img src={scroll} className='scrollLeft' alt="Desça com o dedo para ler mais" />
                        </div>  
                    </div>  
                    <p>
                        Quem diria que a mulher da minha vida estaria a dois andares acima de onde eu morava. Quem conhece nossa história sabe do cuidado de Deus conosco. Os planos de Deus são perfeitos e eu posso provar! 
                        Você é uma mulher temente a Deus, batalhadora e esforçada, admiro muito isso em você. Dona do sorriso lindo e cativante que eu me apaixono todos os dias. Você me faz ser uma pessoa melhor e me apoia em todos os meus projetos. Estou feliz e grato a Deus por ter encontrado a mulher da minha vida.
                        <br/> Está chegando o grande dia e com isso aumenta a vontade de casar logo, juntar nossas coisas e se tornar uma só carne. Viver a vida de adulto e de responsabilidades.
                        Saiba que eu vou me esforçar todos os dias para te fazer feliz. Tenha total certeza que irei amar e cuidar de você, minha princesa. <br/> Te amo!
                    </p>
                </div>
                <div className="img">
                    <img src={wellton} className='welltonImg' alt="Wellton Quirino" />
                </div>
            </div>
        </Container>
    );
}
